// Accordion Style Reveal
export function initializeAccordion() {
    const triggers = document.querySelectorAll(".count-item");
    const contents = document.querySelectorAll(".price-content");

    let activeContent = null;
    let currentIndex = 0;
    let interval;

    // -------------------------
    // INITIAL HIDE OF ALL PANELS
    // -------------------------
    contents.forEach((content) => {
        gsap.set(content, {
            autoAlpha: 0,
            y: 20,
            position: "absolute",
            pointerEvents: "none",
            zIndex: 0,
        });
    });

    // -------------------------
    // INITIALIZE FIRST PANEL
    // -------------------------
    if (triggers.length > 0) {
        const targetId = triggers[0].dataset.target;
        const firstContent = document.getElementById(targetId);

        if (firstContent) {
            gsap.set(firstContent, {
                autoAlpha: 2,
                y: 0,
                pointerEvents: "auto",
                zIndex: 1,
            });

            activeContent = firstContent;
            triggers[0].classList.add("active");
            currentIndex = 0; // IMPORTANT: ensures carousel won't go NaN
        } else {
            console.warn(`Initial content not found: #${targetId}`);
            currentIndex = 0;
        }
    }

    // -------------------------
    // CORE FUNCTION: SWITCH CONTENT
    // -------------------------
    const showContentAtIndex = (index) => {
        // Guard from invalid index
        if (!triggers[index]) {
            console.warn(`Trigger at index ${index} does not exist.`);
            return;
        }

        const trigger = triggers[index];
        const targetId = trigger.dataset.target;
        const targetContent = document.getElementById(targetId);

        // Guard missing dataset or element
        if (!targetId || !targetContent) {
            console.warn(
                `Missing or invalid target for trigger at index ${index}`
            );
            return;
        }

        // Already active
        if (targetContent === activeContent) return;

        // Update classes
        triggers.forEach((t) => t.classList.remove("active"));
        trigger.classList.add("active");

        // Fade out old
        if (activeContent) {
            gsap.to(activeContent, {
                duration: 1,
                autoAlpha: 0,
                ease: "power2.out",
                onStart: () => {
                    activeContent.style.pointerEvents = "none";
                    activeContent.style.zIndex = 0;
                },
            });
        }

        // Fade in new
        gsap.fromTo(
            targetContent,
            { autoAlpha: 0 },
            {
                duration: 1,
                autoAlpha: 1,
                ease: "power2.out",
                onStart: () => {
                    targetContent.style.pointerEvents = "auto";
                    targetContent.style.zIndex = 1;
                },
            }
        );

        activeContent = targetContent;
        currentIndex = index; // Maintain correct index
    };

    // -------------------------
    // CLICK HANDLERS
    // -------------------------
    triggers.forEach((trigger, index) => {
        trigger.addEventListener("click", () => {
            clearInterval(interval); // Pause autoplay
            showContentAtIndex(index);
            startCarousel(); // Resume autoplay
        });
    });

    // -------------------------
    // AUTOPLAY CAROUSEL
    // -------------------------
    const startCarousel = () => {
        // Prevent NaN from leaking to autoplay
        if (isNaN(currentIndex)) currentIndex = 0;

        interval = setInterval(() => {
            if (isNaN(currentIndex)) currentIndex = 0;

            let nextIndex = (currentIndex + 1) % triggers.length;

            showContentAtIndex(nextIndex);
        }, 4000);
    };

    // Start only if desktop triggers exist
    if (triggers.length > 0) {
        startCarousel();
    }
}
